import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 20,
  },
  path: {
    fill: '#690095',
  },
});

const SearchIcon = () => {
  const classes = useStyles();

  return (
    <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
      <path className={classes.path} d="M18.1249 17.2411L13.4048 12.521C14.539 11.1594 15.1046 9.41288 14.9839 7.64485C14.8632 5.87682 14.0655 4.22339 12.7568 3.02851C11.4481 1.83363 9.72909 1.1893 7.95741 1.22956C6.18572 1.26982 4.49776 1.99157 3.24467 3.24467C1.99157 4.49776 1.26982 6.18572 1.22956 7.95741C1.1893 9.72909 1.83363 11.4481 3.02851 12.7568C4.22339 14.0655 5.87682 14.8632 7.64485 14.9839C9.41288 15.1046 11.1594 14.539 12.521 13.4048L17.2411 18.1249L18.1249 17.2411ZM2.4999 8.1249C2.4999 7.01238 2.8298 5.92485 3.44789 4.99982C4.06597 4.07479 4.94447 3.35382 5.97231 2.92808C7.00014 2.50234 8.13114 2.39094 9.22229 2.60799C10.3134 2.82503 11.3157 3.36076 12.1024 4.14743C12.889 4.9341 13.4248 5.93638 13.6418 7.02752C13.8589 8.11866 13.7475 9.24966 13.3217 10.2775C12.896 11.3053 12.175 12.1838 11.25 12.8019C10.325 13.42 9.23742 13.7499 8.1249 13.7499C6.63357 13.7482 5.20379 13.1551 4.14925 12.1006C3.09472 11.046 2.50156 9.61624 2.4999 8.1249V8.1249Z" fill="#1D2125"/>
    </svg>
  );
};

export default SearchIcon;
